import React from "react";
import moment from "moment";
import numeral from "numeral";
import { makeStyles } from "@material-ui/core/styles";

import FuelAnnexViewStyles from "../styles/FuelAnnexViewStyles";

const rounding = (value, method, places = 2) => {
  switch (method) {
    case 'CEIL':
      return +(Math.ceil(value + "e+" + places)  + "e-" + places);
    case 'FLOOR':
      return +(Math.floor(value + "e+" + places)  + "e-" + places);
    default:
      return +(Math.round(value + "e+" + places)  + "e-" + places);
  }
}

const FuelAnnexView = (props) => {
  const classes = makeStyles(FuelAnnexViewStyles)();

  const annexData = props.annexData;

  return (
    <div align="center">
      {annexData.sectors.map((sector, s) => {
        let subTotalFuelSurcharge = 0;
        for (let sectorRoute of sector.routes) {
          subTotalFuelSurcharge +=  sectorRoute.fuelRateDiff * sectorRoute.upliftAmount;
        }

        return (
      <table border="0" cellpadding="0" cellspacing="0" width="1440" className={classes.tableStyle}>
        <tbody>
          <tr height="20" style={{height:"15.0pt"}}>
            <td height="20" className={[classes.backGroundGrey, classes.topLeftBorder].join(' ')} style={{height:"15.0pt"}}>&nbsp;</td>
            <td className={[classes.backGroundGrey, classes.topBorder].join(' ')} >&nbsp;</td>
            <td className={[classes.backGroundGrey, classes.topBorder].join(' ')}>&nbsp;</td>
            <td className={[classes.backGroundGrey, classes.topBorder].join(' ')}>&nbsp;</td>
            <td className={[classes.backGroundGrey, classes.topBorder].join(' ')}>&nbsp;</td>
            <td className={[classes.backGroundGrey, classes.topBorder].join(' ')}>&nbsp;</td>
            <td className={[classes.backGroundGrey, classes.topBorder].join(' ')}>&nbsp;</td>
            <td className={[classes.backGroundGrey, classes.topBorder].join(' ')}>&nbsp;</td>
            <td className={[classes.backGroundGrey, classes.topRightBorder].join(' ')}>&nbsp;</td>
          </tr>
          <tr height="45" style={{height:"34.0pt"}}>
            <td rowspan="2" height="65" className={[classes.headersMain, classes.thinBorder, classes.leftBorder].join(' ')} width="280" style={{height:"49.0pt", width: "210pt"}}>Sector</td>
            <td className={[classes.backGroundGrey]} width="120" style={{width:"90pt"}}>&nbsp;</td>
            {sector.sectorType === "BASE" ?
            <td rowspan="2" className={[classes.headersMain, classes.thinBorder, classes.noRightBorder].join(' ')} width="200" style={{width:"150pt"}}>Base Rate</td>
            :
            <td className={[classes.headersMain, classes.thinLeftTopBorder].join(' ')} width="200" style={{width:"150pt"}}>Over Pivot Rate</td>
            }
            <td className={[classes.headersMain, classes.thinLeftTopBorder].join(' ')} width="120" style={{width:"90pt"}}>Average Fuel</td>
            <td className={[classes.headersMain, classes.thinLeftTopBorder].join(' ')} width="120" style={{width:"90pt"}}>Fuel Rate</td>
            <td className={[classes.headersMain, classes.thinLeftTopBorder].join(' ')} width="120" style={{width:"90pt"}}>Difference</td>
            <td className={[classes.headersMain, classes.thinLeftTopBorder].join(' ')} width="200" style={{width:"150pt"}}>Fuel Surcharge</td>
            <td className={[classes.headersMain, classes.thinLeftTopBorder].join(' ')} width="160" style={{width:"120pt"}}>Sub Total Fuel</td>
            <td className={[classes.headersMain, classes.thinNoBottomBorder].join(' ')} width="200" style={{width:"150pt"}}>
              Charter Rate and Fuel Surcharge Effective:
            </td>
          </tr>
          <tr height="20" style={{height: "15.0pt"}}>
            <td height="20" className={[classes.backGroundGrey]} style={{height: "15.0pt"}}>&nbsp;</td>
            {sector.sectorType !== "BASE" ?
            <td className={[classes.headersSub, classes.thinLeftBottomBorder].join(' ')}>(Inc Fuel)</td>
            :<></>
            }
            <td className={[classes.headersSub, classes.thinLeftBottomBorder].join(' ')}>Uplift (USG)</td>
            <td className={[classes.headersSub, classes.thinLeftBottomBorder].join(' ')} >(US$/USG)</td>
            <td className={[classes.headersSub, classes.thinLeftBottomBorder].join(' ')} >+/-</td>
            <td className={[classes.headersSub, classes.thinLeftBottomBorder].join(' ')} >&nbsp;</td>
            <td className={[classes.headersSub, classes.thinLeftBottomBorder].join(' ')} >Surcharge</td>
            <td className={[classes.headersSub, classes.thinNoTopBorder].join(' ')} style={{fontSize: "11pt", color: "#B71717"}}>{moment(props.effectiveDate).format('DD/MM/YYYY')}</td>
          </tr>
          <tr height="20" style={{height: "15.0pt"}}>
            <td height="20" className={[classes.backGroundGrey, classes.leftBorder].join(' ')} style={{height: "15.0pt"}}>&nbsp;</td>
            <td className={[classes.backGroundGrey].join(' ')}>&nbsp;</td>
            <td className={[classes.backGroundGrey].join(' ')}>&nbsp;</td>
            <td className={[classes.backGroundGrey].join(' ')}>&nbsp;</td>
            <td className={[classes.backGroundGrey].join(' ')}>&nbsp;</td>
            <td className={[classes.backGroundGrey].join(' ')}>&nbsp;</td>
            <td className={[classes.backGroundGrey].join(' ')}>&nbsp;</td>
            <td className={[classes.backGroundGrey].join(' ')}>&nbsp;</td>
            <td className={[classes.backGroundGrey, classes.rightBorder].join(' ')}>&nbsp;</td>
          </tr>
          {sector.routes.map((route,r) => {
            const dayType = sector.day && sector.day.length > 1 ? "Days" : "Day";
            const sectorDay = sector.day ? ` ( ${dayType} ${sector.day} )` : "";
            const commodity = sector.commodity ? " (" + sector.commodity +")": "";
            const baseSubTotal = rounding(subTotalFuelSurcharge, sector.roundingMethod, 2);
            const baseTotal = rounding((sector.baseRate + subTotalFuelSurcharge), sector.roundingMethod, 2) ;
            const kgSubTotal = baseSubTotal / sector.usablePayload + (baseSubTotal && (sector.roundingMethod||'NEXT CENT') === 'NEXT CENT' ? 0.01 : 0);
            const kgTotal = sector.overPivotRate + kgSubTotal;
            const surcharge = Math.round(route.upliftAmount / sector.usablePayload * sector.usablePayload) / 100;

            return (
              <>
          <tr height="20" style={{height: "15.0pt"}}>
            <td rowspan="3" height="60" className={[classes.headersMain, classes.thinBorder, classes.leftBorder, (r === (sector.routes.length - 1)?'':classes.noBottomBorder) ].join(' ')} style={{height: "45.0pt"}}>{route.originAirportCode} - {route.destinationAirportCode}{commodity||sectorDay?<br/>:""}{commodity}{sectorDay}</td>
            <td className={[classes.backGroundGrey].join(' ')}>&nbsp;</td>
            {r === 0 ?
            <td rowspan={3 * sector.routes.length} className={[classes.headersMain, classes.thinBorder, classes.noRightBorder, classes.backGroundYellow].join(' ')}>{numeral(sector.sectorType === "BASE" ? sector.baseRate : sector.overPivotRate).format('$0,0.00')}</td>
            : <></>}
            <td className={[classes.thinLeftTopBorder].join(' ')} >{numeral(route.upliftAmount).format('0,0')}</td>
            <td className={[classes.thinLeftTopBorder].join(' ')} style={{fontWeight:700}}>{route.originAirportCode}</td>
            <td className={[classes.thinLeftTopBorder].join(' ')} >&nbsp;</td>
            <td className={[classes.thinLeftTopBorder].join(' ')} style={{fontSize:"10pt"}}>${surcharge} per US$0.01/USG +/-</td>
            {r === 0 ?
            <td rowspan={3 * sector.routes.length} className={[classes.headersMain, classes.thinBorder, classes.noRightBorder].join(' ')}>{numeral(sector.sectorType === "BASE" ? baseSubTotal : kgSubTotal).format('$0,0.00')}</td>
            : <></>}
            {r === 0 ?
            <td rowspan={3 * sector.routes.length} className={[classes.headersMain, classes.thinBorder, classes.backGroundGreen].join(' ')}>{numeral(sector.sectorType === "BASE" ? baseTotal : kgTotal).format('$0,0.00')}</td>
            : <></>}
            </tr>
          <tr height="20" style={{height: "15.0pt"}}>
            <td height="20" className={[classes.backGroundGrey].join(' ')} style={{height: "15.0pt"}}>&nbsp;</td>
            <td className={[classes.thinLeftBorder].join(' ')}>{moment(sector.baseFuelDate).format('DD/MM/YYYY')}</td>
            <td className={[classes.thinLeftBorder].join(' ')} >{numeral(route.baseFuelRate).format('0,0.0[0000]')}</td>
            <td className={[classes.thinLeftBorder].join(' ')} >&nbsp;</td>
            <td className={[classes.thinLeftBorder].join(' ')} >&nbsp;</td>
          </tr>
          <tr height="20" style={{height: "15.0pt"}}>
            <td height="20" className={[classes.backGroundGrey].join(' ')} style={{height: "15.0pt"}}>&nbsp;</td>
            <td className={[(r === (sector.routes.length - 1)?classes.thinLeftBottomBorder:classes.thinLeftBorder)].join(' ')} style={{fontWeight: 700, color: "#B71717"}}>{moment(props.effectiveDate).format('DD/MM/YYYY')}</td>
            <td className={[(r === (sector.routes.length - 1)?classes.thinLeftBottomBorder:classes.thinLeftBorder), classes.backGroundYellow].join(' ')} style={{fontWeight: 700}}>{numeral(route.newFuelRate).format('0,0.0[0000]')}</td>
            <td className={[(r === (sector.routes.length - 1)?classes.thinLeftBottomBorder:classes.thinLeftBorder)].join(' ')}>{numeral(route.fuelRateDiff).format('0,0.0[0000]')}</td>
            <td className={[(r === (sector.routes.length - 1)?classes.thinLeftBottomBorder:classes.thinLeftBorder)].join(' ')}>{numeral(route.fuelRateDiff * route.upliftAmount).format('$0,0.00')}</td>
          </tr>
          </>
            )
          })}
          <tr height="20" style={{height: "15.0pt"}}>
            <td height="20" className={[classes.backGroundGrey, classes.bottomLeftBorder].join(' ')} style={{height: "15.0pt"}}>&nbsp;</td>
            <td className={[classes.backGroundGrey, classes.bottomBorder].join(' ')}>&nbsp;</td>
            <td className={[classes.backGroundGrey, classes.bottomBorder].join(' ')}>&nbsp;</td>
            <td className={[classes.backGroundGrey, classes.bottomBorder].join(' ')}>&nbsp;</td>
            <td className={[classes.backGroundGrey, classes.bottomBorder].join(' ')}>&nbsp;</td>
            <td className={[classes.backGroundGrey, classes.bottomBorder].join(' ')}>&nbsp;</td>
            <td className={[classes.backGroundGrey, classes.bottomBorder].join(' ')}>&nbsp;</td>
            <td className={[classes.backGroundGrey, classes.bottomBorder].join(' ')}>&nbsp;</td>
            <td className={[classes.backGroundGrey, classes.bottomRightBorder].join(' ')}>&nbsp;</td>
          </tr>
          {(sector.surcharges && sector.surcharges.length > 0) ? <>
          <tr height="20" style={{height: "15.0pt"}}>
            <td height="20" className={[classes.leftBorder].join(' ')} style={{height: "15.0pt"}}>&nbsp;</td>
            <td colspan="7"></td>
            <td className={[classes.rightBorder].join(' ')}>&nbsp;</td>
          </tr>
          <tr height="21" className={[classes.headersMain].join(' ')} style={{height: "16.0pt"}}>
            <td height="21" className={[classes.leftBorder].join(' ')} style={{height: "16.0pt"}}>&nbsp;</td>
            <td className={[classes.backGroundGrey].join(' ')}>Surcharge Type</td>
            <td className={[classes.backGroundGrey].join(' ')}>Surcharge Name</td>
            <td className={[classes.backGroundGrey].join(' ')}>Airport</td>
            <td className={[classes.backGroundGrey].join(' ')}>Days</td>
            <td className={[classes.backGroundGrey].join(' ')}>Currency</td>
            <td className={[classes.backGroundGrey].join(' ')}>Amount</td>
            <td className={[classes.backGroundGrey].join(' ')}>Validity</td>
            <td className={[classes.backGroundGrey, classes.rightBorder].join(' ')}>Notes</td>
          </tr>
          {sector.surcharges.map((surcharge) => (
          <tr height="20" style={{height: "15.0pt", fontSize:"10pt"}}>
            <td height="20" className={[classes.bottomLeftBorder].join(' ')} style={{height: "15.0pt"}}>&nbsp;</td>
            <td className={[classes.bottomBorder].join(' ')}>{surcharge.surchargeType}</td>
            <td className={[classes.bottomBorder].join(' ')}>{surcharge.surchargeName}</td>
            <td className={[classes.bottomBorder].join(' ')}>{surcharge.airportCode}</td>
            <td className={[classes.bottomBorder].join(' ')}>{surcharge.days}</td>
            <td className={[classes.bottomBorder].join(' ')}>{surcharge.currencyCode}</td>
            <td className={[classes.bottomBorder].join(' ')}>{numeral(surcharge.amount).format('0,0.00')}</td>
            <td className={[classes.bottomBorder].join(' ')}>{moment(surcharge.validFrom).format('DD/MM/YYYY')}-{moment(surcharge.validTo).format('DD/MM/YYYY')}</td>
            <td className={[classes.bottomRightBorder].join(' ')}>{surcharge.notes}</td>
          </tr>
          ))}
          </>
          :<></>
          }
          <tr height="20" style={{height: "15.0pt"}}>
            <td height="20" style={{height: "15.0pt"}}>&nbsp;</td>
            <td>&nbsp;</td>
            <td>&nbsp;</td>
            <td>&nbsp;</td>
            <td>&nbsp;</td>
            <td>&nbsp;</td>
            <td>&nbsp;</td>
            <td>&nbsp;</td>
            <td>&nbsp;</td>
          </tr>
        </tbody>
      </table>
        );
      })}
    </div>
  )
}

export default FuelAnnexView;